// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"1230f5ae","733":"a48fb8cd","851":"1230f5ae","877":"1230f5ae"}[chunkId] + ".chunk.css";
};